<template>
  <div class="patentList fatherHeight">
    <div id="piaoju" style="display: none;">
      <div class="hiprint-printTemplate" v-for="(pageItem,index1) in pageData" :key="index1">
        <div class="hiprint-printPanel panel-index-0" :id='"panelChang"+index1'>
          <div class="hiprint-printPaper" original-height="297"
            style="width: 210mm; height: 297mm;">
            <div class="hiprint-printPaper-content">
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="font-size: 18pt;position: absolute; width: 295pt; height: 21pt; font-size: 18pt; font-weight: 600; letter-spacing: 2.5pt; color: rgb(41, 53, 227); text-align: center; line-height: 18pt; left: 150pt; top: 15pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">长期医嘱单</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="font-size: 13pt;position: absolute; width: 150pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 20pt; top: 55pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">姓名：{{info.name}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="font-size: 13pt;position: absolute; width: 100pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 120pt; top: 55pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">性别：{{info.dict_sex_name}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="font-size: 13pt;position: absolute; width: 100pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 180pt; top: 55pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">年龄：{{info.age}}</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="font-size: 13pt; position: absolute; width: 140pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 250pt; top: 55pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">卡号：</div>
              </div>
              <div tabindex="1" class="hiprint-printElement hiprint-printElement-text"
                style="font-size: 13pt; position: absolute; width: 140pt; height: 15pt; color: rgb(41, 53, 227); text-align: left; line-height: 13pt; left: 412pt; top: 55pt;">
                <div class="hiprint-printElement-text-content hiprint-printElement-content"
                  style="height:100%;width:100%">病历号：</div>
              </div>
              <div class="hiprint-printElement hiprint-printElement-text"
                style="position: absolute; width: 80pt; height: 12pt; color: rgb(41, 53, 227); left: 12pt; top: 75pt;">
                <table border="1" cellpadding="0" cellspacing="0"
                  style="text-align: center;width: 560pt; height: 20pt; color: rgb(41, 53, 227); font-size: 12pt;">
                  <tr style="text-align: center;width: 560pt; height: 20pt; color: rgb(41, 53, 227); font-size: 12pt;">
                    <td colspan="2">起始</td>
                    <td width="400" rowspan="2">医嘱</td>
                    <td rowspan="2" width="80">医生签名</td>
                    <td rowspan="2" width="80">执行护士签名</td>
                    <td colspan="4">停止</td>
                  </tr>
                  <tr style="text-align: center;width: 560pt; height: 20pt; color: rgb(41, 53, 227); font-size: 12pt;">
                    <td width="60">日期</td>
                    <td width="60">时间</td>
                    <td width="60">日期</td>
                    <td width="60">时间</td>
                    <td width="80">医生签名</td>
                    <td width="80">执行护士签名</td>
                  </tr>
                  <tr v-for="(item,index) in pageItem" :key="index"
                    style="text-align: center;width: 560pt; height: 40pt; line-height:15pt;color: rgb(41, 53, 227); font-size: 12pt;">
                    <td>{{item.created_date}}</td>
                    <td>{{item.created_time}}</td>
                    <!-- <td width="200">{{item.drug}} {{item.dosage}}{{item.dict_dosage_unit_name}}
                      {{item.dict_frequency_name}}</td> -->
                      <td width="200">{{item.drug}} <span v-if="item.dict_advice_type== '163110000'">{{item.dosage}}({{item.dict_dosage_unit_name}})
                        {{item.dict_use_way_name}}{{item.dict_frequency_name}}</span><span v-if="item.dict_advice_type== '163120000'">{{item.medi_spec}}{{item.num}}
                          ({{item.dict_first_unit_name}})</span></td>
                    <td>{{item.doctor.name}}</td>
                    <td>{{item.do_user_id_name}}</td>
                    <td>{{item.end_time1}}</td>
                    <td>{{item.end_time2}}</td>
                    <td></td>
                    <td></td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { ref, onMounted, defineExpose } from 'vue';
  const info = ref('')
  const pageData = ref([])
  const tableData = ref([])
  const page = 1
  const pageSize = 15
  onMounted(() => {

  })
  const initData = (item) => {
    info.value = ''
    tableData.value = []
    pageData.value = []
    info.value = item
    tableData.value = JSON.parse(JSON.stringify(info.value.drug_list))
    console.log(tableData.value, 222)
    tableData.value.forEach(item => {
      console.log(item.end_time)
      if (item.end_time != null) {
        item.end_time1 = item.end_time.substring(0, 10)
        item.end_time2 = item.end_time.substring(11, 19)
      } else {
        item.end_time1 = ''
        item.end_time2 = ''
      }

    })
    for (let i = 0; i < Math.ceil(tableData.value.length / pageSize); i++) {
      // pageData.value.push([])
      pageData.value[i] = tableData.value.slice(i * pageSize, (i + 1) * pageSize)
    }
    console.log(pageData, 333)
  }
  //A4的panel设置
  const a4Panel = { width: 210, height: 297, paperFooter: 290, paperHeader: 10, paperNumberDisabled: true,'orient': 1 }
  import { autoConnect, disAutoConnect, hiprint, defaultElementTypeProvider } from 'vue-plugin-hiprint'
  // disAutoConnect()// 取消自动连接直接打印客户端
  hiprint.init()//初始化
  const print = (title) => {
    let hiprintTemplate = new hiprint.PrintTemplate();
    pageData.value.forEach((item, index) => {
      let panel = hiprintTemplate.addPrintPanel(a4Panel);
      panel.addPrintHtml({ options: { width: 210, height: 297, top: 0, left: 10, content: $('#panelChang' + index).html() } });
    })
    hiprintTemplate.print();
  }
  defineExpose({
    info,
    print,
    initData
  })
</script>
<style scoped>
  .patentList {
    background-color: #fff;
  }
</style>